<template>
  <div class="addMain wraper">
    <template>
      <el-backtop target=".wraper"></el-backtop>
    </template>
  <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
        <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
       <el-breadcrumb-item v-for="(item,index)  in routeList" 
       :key="index"
      :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
      {{item.name}}
        </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 创建网关第一步 -->
    <el-card shadow="never" v-if="step">
      <div class="cardTop">
        <h1 v-if="flag != 'edit'">创建网关</h1>
        <h1 v-if="flag == 'edit'">更新网关</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3 v-if="flag != 'edit'">请完善网关设备的基本信息。</h3>
          <h3 v-if="flag == 'edit'">网关设备的基本信息。</h3>
        </div>
        <el-form ref="addForm" :model="addForm" :rules="rules">
          <el-form-item label="名称" prop="name"
            ><br />
            <div class="subheading">输入网关名称，方便辨别网关。</div>
            <el-input v-model="addForm.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="网关编号" prop="code"
            ><br />
            <div class="subheading">
              请输入网关编号
            </div>
            <el-input v-model="addForm.code" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="操作系统" prop="os"
            ><br />
            <div class="subheading">请选择网关操作系统</div>
            <el-select v-model="addForm.os" filterable placeholder="未选择">
              <el-option
                v-for="item in osList"
                :key="item.id"
                :label="item.content"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="SIM卡ICCID" prop="simIccid"
            ><br />
            <div class="subheading">
              可输入网关内SIM卡ICCID，以获取SIM卡使用状态。
            </div>
            <el-input
              v-model="addForm.simIccid"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="品牌" prop="brand"
            ><br />
            <div class="subheading">请选择网关品牌，可搜索后选择。</div>
            <el-select
              v-model="addForm.brand"
              filterable
              placeholder="未选择"
              @change="beandChange"
            >
              <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.content"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="型号" prop="model" v-if="addForm.brand != null"
            ><br />
            <div class="subheading">请选择网关型号，可搜索后选择。</div>
            <el-select v-model="addForm.model" filterable placeholder="未选择">
              <el-option
                v-for="item in modelList"
                :key="item.id"
                :label="item.content"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="北向联网方式" prop="northLinkType"
            ><br />
            <div class="subheading">
              请选北向联网方式，即网关给云平台上传数据的方式，可多选。
            </div>
            <div class="checkeds">
              <el-checkbox-group v-model="addForm.northLinkType">
                <el-checkbox
                  v-for="(val, index) in northLinkType"
                  :key="index"
                  :label="val.id"
                  border
                  >{{ val.content }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="南向联网方式" prop="southLinkType"
            ><br />
            <div class="subheading">
              请选南向联网方式，即网关提供给设备的连接方式，可多选。
            </div>
            <div class="checkeds">
              <el-checkbox-group v-model="addForm.southLinkType">
                <el-checkbox
                  v-for="(val, index) in southLinkType"
                  :key="index"
                  :label="val.id"
                  border
                  >{{ val.content }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="备注" prop="remarks"
            ><br />
            <div class="subheading">根据需要，输入网关备注信息。</div>
            <el-input
              type="textarea"
              :rows="3"
              v-model="addForm.remarks"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="$router.history.go(-1)"
              >取消</el-button
            >
            <el-button
              v-if="flag != 'edit'"
              type="primary"
              @click="onSubmit('addForm')"
              >创建网关</el-button
            >
            <el-button
              v-if="flag == 'edit'"
              type="primary"
              @click="editOnSubmit('addForm')"
              >更新网关</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 配置网关 -->
    <el-card shadow="never" v-if="!step">
      <div class="cardTop">
        <h1>配置网关</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3>
            请将网关设备接入电脑后，在网关配置页面配置以下信息，这些信息也可在网关详情页查看。
          </h3>
        </div>
        <el-form :model="addForm2">
          <el-form-item label="IP地址"
            ><br />
            <div class="subheading">请在网关配置页面配置此IP地址。</div>
            <p class="addInformation">{{ addForm2.ipAddress }}</p>
          </el-form-item>
          <el-form-item label="端口"
            ><br />
            <div class="subheading">
              请在网关配置页面配置此端口。
            </div>
            <p class="addInformation">{{ addForm2.port }}</p>
          </el-form-item>
          <el-form-item label="用户名"
            ><br />
            <div class="subheading">
              请在网关配置页面配置此用户名。
            </div>
            <p class="addInformation">{{ addForm2.userName }}</p>
          </el-form-item>
          <el-form-item label="身份密钥"
            ><br />
            <div class="subheading">
              请在网关配置页面配置此密钥。
            </div>
            <p class="addInformation">{{ addForm2.password }}</p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="completeBtn">完成</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import API from "../../api/api";
export default {
  data() {
    return {
      flag: this.$route.query.flag,
      routeList:this.$route.meta.routeList,
      step: true, //默认是创建网关显示
      rules: {
        name: [{ required: true, message: "请输入网关名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入网关编号", trigger: "blur" }]
      },
      addForm: {
        northLinkType: [],
        southLinkType: [],
        model: "",
        type: 2
      }, //创建网关数据
      addForm2: {}, //配置网关数据
      northLinkType: [], //北向联网方式数据
      southLinkType: [], //南向联网方式数据
      osList: [], //操作系统下拉
      brandList: [], //品牌下拉数据
      modelList: [] //型号下拉数据
    };
  },
  created() {},
  methods: {
    //当页面为编辑状态flag==edit时要获取到当前编辑的信息
    getMage() {
      if (this.flag == "edit") {
        let id = this.$route.query.id;
        API.platformMduModule(id).then(res => {
          if (res.code == 1) {
            if (res.data.southLinkType != null) {
              res.data.southLinkType = res.data.southLinkType.split(",");
            }
            if (res.data.northLinkType != null) {
              res.data.northLinkType = res.data.northLinkType.split(",");
            }
            //根据品牌获取型号下拉数据
            API.platformMduModuleModelList(res.data.brand).then(res => {
              if (res.code == 1) {
                this.modelList = res.data.dictionaryList;
              }
            });
            this.addForm = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        return false;
      }
    },
    //获取所有新增页面所有的数据
    getData() {
      API.platformMduModuleAddData().then(res => {
        if (res.code == 1) {
          this.brandList = res.data.dictionaryList.moduleBrand; //品牌下拉数据
          this.osList = res.data.dictionaryList.os;
          this.southLinkType = res.data.dictionaryList.southLinkType;
          this.northLinkType = res.data.dictionaryList.northLinkType;
        }
      });
    },
    //根据品牌下拉数据获取型号
    beandChange(val) {
      this.addForm.model = ""; //品牌改变，型号清空
      API.platformMduModuleModelList(val).then(res => {
        if (res.code == 1) {
          this.modelList = res.data.dictionaryList;
        }
      });
    },
    //创建网关
    onSubmit(formName) {
      let _this = this;
      let _API = API;
      this.$refs[formName].validate(valid => {
        if (valid) {
          _API.addPlatformMduModule(_this.addForm).then(res => {
            if (res.code == 1) {
              _this.$message({
                message: "创建网关成功",
                type: "success"
              });
              let ids = res.data;
              //获取网关id获取网关配置
              _API.platformMduModuleGatewayConfig(ids).then(res => {
                if (res.code == 1) {
                  _this.addForm2 = res.data;
                  _this.step = false;
                }
              });
            } else {
              _this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
        } else {
          _this.$message({
            message: "请填写完所有必填项",
            type: "error"
          });
          return false;
        }
      });
    },
    //更新网关
    editOnSubmit(formName) {
      let _this = this;
      let _API = API;
      this.$refs[formName].validate(valid => {
        if (valid) {
          _API
            .editPlatformMduModule(this.$route.query.id, _this.addForm)
            .then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: "更新网关成功",
                  type: "success"
                });
                //获取网关id获取网关配置
                _API
                  .platformMduModuleGatewayConfig(this.$route.query.id)
                  .then(res => {
                    if (res.code == 1) {
                      _this.addForm2 = res.data;
                      _this.step = false;
                    }
                  });
              } else {
                _this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
        } else {
          _this.$message({
            message: "请填写完所有必填项",
            type: "error"
          });
          return false;
        }
      });
    },
    //完成（配置）
    completeBtn() {
      this.$router.push({
        path: "/device/gatewayManagement"
      });
    }
  },
  mounted() {
    this.getData();
    this.getMage();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/platform/gatewayAdd.vue